import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2ReportDefinitionService {
    constructor(private dataTask: DataTaskService) {}

    public async getDefinition(params: P2ReportDefinitionParams): Promise<P2ReportDefinitionGet> {
        return (await this.dataTask.Post(334, params))[0];
    }

    public async saveDefinition(definition: P2ReportDefinitionGet): Promise<void> {
        await this.dataTask.Post(336, definition);
    }

    public listWebPages(): Promise<Item[]> {
        return this.dataTask.Post(4);
    }

    public listReportTypes(): Promise<P2ReportType[]> {
        return this.dataTask.Post(3375);
    }

    public listHtmlReports(): Promise<Item[]> {
        return this.dataTask.Post(3361);
    }

    public setUserReportPrinter(reportKeyno: string | number, printerKeyno: string | number, portalUserKeyno: string | number): Promise<unknown> {
        return this.dataTask.Post(550, {
            reportKeyno,
            defaultPrinterKeyno: printerKeyno,
            portal_user_keyno: portalUserKeyno,
        });
    }

    public async getSettings(): Promise<P2ReportDefinitionsSettings> {
        return (await this.dataTask.Post(1026))[0];
    }

    public listReports(): Promise<Item[]> {
        return this.dataTask.Post(333);
    }

    public listPrinters(): Promise<Item[]> {
        return this.dataTask.Post(337);
    }

    public listClients(): Promise<Item[]> {
        return this.dataTask.Post(532);
    }

    public async updateReports(reports: object): Promise<void> {
        await this.dataTask.Post(529, reports);
    }

    public async updatePrinters(printers: object): Promise<void> {
        await this.dataTask.Post(530, printers);
    }

    public async updateClients(clients: object): Promise<void> {
        await this.dataTask.Post(531, clients);
    }
}

export interface P2ReportDefinitionParams {
    p2_reportdef_keyno: string;
}

export interface P2ReportDefinitionGet extends P2ReportDefinitionParams {
    report_type_keyno: string;
    printserver_keyno: string;
    htmlreport_keyno: string;
    word_id_report_name: string;
    word_id_report_name_translated: string;
    word_id_report_description: string;
    word_id_report_description_translated: string;
    report_filename: string;
    doccategory_keyno: string;
    report_filename_template: string;
    edi_type_keyno: string;
    p2_webpage_keyno: string;
    print_landscape: '0' | '1';
    enabled: '0' | '1';
    show_is_published: '0' | '1';
    is_published: '0' | '1';
    std_attachment: '0' | '1';
    paper_size_id: string;
    width: number;
    height: number;
    custom_margins: '0' | '1';
    margin_top: number;
    margin_right: number;
    margin_bottom: number;
    margin_left: number;
    show_retrievearguments: '0' | '1';
    show_arg_businessco_no: '0' | '1';
    show_arg_datefomtom: '0' | '1';
    default_printer: string;
}

export interface P2ReportType {
    report_type_keyno: string;
    report_type_name: string;
}

export interface P2ReportDefinitionsSettings {
    filtervalue_reports: string;
}
